import App from 'next/app'
import React from 'react'

//* HOCs
import UIProvider from 'context/providers/UIProvider'
import DataProvider from 'context/providers/DataProvider'
import UserProvider from 'context/providers/UserProvider'

//* Helpers
import { getUser } from "helpers/_getUser"

//* Components
import AppHeader from 'components/common/AppHeader'
import AppFooter from 'components/common/AppFooter'
import Popup from 'components/common/Popup'
import BackTop from 'components/common/BackTop'

//* Style
import 'antd/dist/antd.css'
import 'styles/icons/style.css'
import 'styles/common/font.css'


class MyApp extends App {

    static async getInitialProps({ Component, ctx, router, ...props }) {
        if (!process.browser) {
            let userData = {
                isLoggedIn: false
            }

            //! Getting User Data
            userData = await getUser(ctx.locale, userData, ctx)

            return {
                pageProps: {
                    browser: false
                },
                userProps: userData.newState
            }
        } else {
            return {
                pageProps: {
                    browser: true
                },
            }
        }
    }

    render() {
        const { Component, pageProps, userProps } = this.props

        return (
            <UIProvider>
                <DataProvider>
                    <UserProvider userProps={userProps}>
                        <AppHeader />
                        <Component {...pageProps} />
                        <AppFooter />
                        <Popup />
                        <BackTop />
                    </UserProvider>
                </DataProvider>
            </UIProvider>
        )
    }
}

export default MyApp
